import { sortBy } from "lodash";

export enum GenderEnum {
  Male = "Male",
  Female = "Female",
}

export type ClothItem = {
  componentId: number;
  drawableId: number;
  textureId: number;
  paletteId: number;
};

export type Config = Record<
  GenderEnum,
  {
    hairs: number[];
    hats: PropItem[];
    legs: ClothItem[];
    shoes: ClothItem[];
    tops: ClothItem[];
  }
>;

export type PropItem = {
  propId: number;
  drawableId: number;
  textureId: number;
};

export const CUSTOMIZATION_FATHERS: number[] = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 42, 43, 44,
];

export const CUSTOMIZATION_MOTHERS: number[] = [
  21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 45,
];

export const CUSTOMIZATION_TRANS: number[] = sortBy(
  [...CUSTOMIZATION_FATHERS, ...CUSTOMIZATION_MOTHERS],
  (item) => item,
);
